import './fonts/HKGrotesk-SemiBold.otf';
import './fonts/HKGrotesk-Bold.otf';
import './fonts/HKGrotesk-Regular.otf';


import React, { Component } from 'react';
import IconeHay from "./images/logo-loading.png";

import { Helmet } from 'react-helmet';
import { createBrowserRouter, RouterProvider, Navigate } from "react-router";

import LayoutPrincipal from "./pages/Layout/LayoutPrincipal";
import PaginaNaoExiste from "./pages/PaginaNaoExiste";

import Loader from './components/ui/loader';

import 'animate.css/animate.css'
import './css/geral.css';

import { Toast } from 'primereact/toast';
import Dashboard from './pages/Dashboard';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
          
        }
    }
    
    async componentDidMount() {
        
    }

    render() {
        this.router = createBrowserRouter([
            {
                element: <LayoutPrincipal  />,
                children: [
                    {                        
                        path: "/dashboard",
                        element: <Dashboard  />,
                    },
                    {
                        path: "/*",
                        element: <PaginaNaoExiste />,
                    },
                ],
            }
        ]);
        return (
            <>
                <Helmet>
                    <title>{'HaY Systems - Release Notes'}</title>
                    <meta name="description" content={'Heitor Trevisan Games'} />
                    <meta name="google" content="notranslate" />
                    <link className="icone-app" rel="apple-touch-icon" href={IconeHay} />
                    <link className="icone-app" rel="icon" href={ IconeHay} />
                </Helmet>                
                <RouterProvider router={this.router} />
                <Loader  /> 
                <Toast ref={(ref) => this.refs.toast = ref} />
            </>
        )
    }
}
export default App;